import * as React from "react";
import ButtonLanding from "./ButtonLanding.primitive";
function CadreLanding({
  text,
  nextPage,
  margin,
  textButton = "DEMANDER UNE DÉMONSTRATION"
}: {
  text: string;
  nextPage: (value: any) => any;
  margin: string;
  textButton?: string;
}) {
  return (
    <div>
      <div className={"box-solution is-background-white" + margin} style={{ position: "relative" }}>
        <h3 className="text-cadre-landing text-open-sans">{text}</h3>
        <div className="margin-top-m-fixe">
          <ButtonLanding text={textButton} nextPage={nextPage} />
        </div>
      </div>
    </div>
  );
}

export default CadreLanding;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/CadreLanding.primitive.tsx